import { render } from "./AdsUpdating.vue?vue&type=template&id=3687163e&ts=true"
import script from "./AdsUpdating.vue?vue&type=script&lang=ts"
export * from "./AdsUpdating.vue?vue&type=script&lang=ts"

import "./AdsUpdating.vue?vue&type=style&index=0&id=3687163e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__